import { useQuery } from '@hooks/reactQuery';

import { getConsistencyCheckHistoryHistory } from '@api/consistencyCheckParameters';

import { extractQueryParams } from '@utils/common';

import { IConsistencyCheckHistory } from '@interfaces/cmModule/consistencyCheck';
import { TConsistencyCheckHistoryDTO } from '@interfaces/cmModule/dto/consistencyCheckDTO';

import { EUserRoles } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { CONSISTENCY_CHECK_HISTORY } from '@constants/queryKeys';

interface IUseConsistencyCheckHistoryReturned {
	consistencyCheckHistory: IConsistencyCheckHistory[];
	countOfRecords: number;
	isLoadingConsistencyCheckHistory: boolean;
}

const useConsistencyCheckHistory = (params: TConsistencyCheckHistoryDTO): IUseConsistencyCheckHistoryReturned => {
	const {
		data,
		isInitialLoading,
		isFetching,
	} = useQuery({
		queryKey: [CONSISTENCY_CHECK_HISTORY, params],
		queryFn: extractQueryParams(getConsistencyCheckHistoryHistory),
		enabled: [
			!!params.page,
			!!params.pageSize,
			!!params.consistencyId,
		],
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleViewer,
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
		...refetchOptions,
	});

	return {
		consistencyCheckHistory: data?.items || [],
		countOfRecords: data?.count || 0,
		isLoadingConsistencyCheckHistory: isInitialLoading || isFetching,
	};
};

export default useConsistencyCheckHistory;
